import { render, staticRenderFns } from "./saveDialog.vue?vue&type=template&id=40874f0a"
import script from "./saveDialog.vue?vue&type=script&lang=js"
export * from "./saveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports